import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Page, Version } from 'src/app/interfaces/page';
import { FirestoreService } from 'src/app/services/firestore.service';
import {
  DocumentReference,
  DocumentSnapshot,
  QuerySnapshot,
} from '@angular/fire/firestore';
import { SharedService } from 'src/app/services/shared.service';
import { Product } from 'src/app/interfaces/product';
import { Element } from 'src/app/interfaces/element';
import { Pattern } from 'src/app/interfaces/pattern';

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss'],
})
export class PageComponent implements OnInit {
  addToCollectionModalVisible = false;
  page?: Page;
  selectedVersion?: Version;
  versions?: Version[];
  tags: {
    elements?: Element[];
    patterns?: Pattern[];
  };

  constructor(
    private route: ActivatedRoute,
    private firestoreService: FirestoreService,
    public sharedService: SharedService
  ) {}

  ngOnInit(): void {
    this.subscribeToRoute();
  }

  // if uid exists and is different than set page
  private subscribeToRoute(): void {
    this.route.params.subscribe((params: Params) => {
      // if version changed and versions are fetched, select it
      if (params.version && this.versions) {
        this.selectVersion(params.version);
      }
      if (params.uid && params.uid !== this.page?.uid) {
        // first, set page
        this.getPage(params.uid).then(() => {
          // then get versions of the page
          this.getVersions().then(() => {
            // then select version by param or latest on array
            this.selectVersion(
              params.version
                ? params.version
                : this.versions[this.versions.length - 1].uid
            );
          });
        });
      }
    });
  }

  private selectVersion(versionUid: string) {
    this.selectedVersion = this.versions.find(
      (version) => version.uid === versionUid
    );
  }

  // get and set page document
  private getPage(pageUid: string): Promise<void> {
    return new Promise((resolve) => {
      this.firestoreService
        .getDocument(`pages/${pageUid}`)
        .then((pageDocSnapshot: DocumentSnapshot<Page>) => {
          this.page = pageDocSnapshot.data();
          this.setTags(<any>this.page.tags);
          this.getProduct(this.page.product);
          resolve();
        });
    });
  }

  private setTags(refs: DocumentReference<any>[]) {
    // reset tags prior to getting it
    this.tags = { patterns: [], elements: [] };
    refs.forEach((tag) => {
      // get id of tag collection
      const collectionUid = tag.path.split('/')[0];
      // then replace dash with spaces and push if to array
      this.tags[collectionUid]?.push(tag.id.replace('-', ' '));
    });
  }

  private getVersions(): Promise<void> {
    return new Promise((resolve) => {
      this.firestoreService
        .getCollection(`pages/${this.page?.uid}/versions`)
        .then((versionsQuerySnapshot: QuerySnapshot<Version>) => {
          // reset array of versions
          this.versions = [];
          for (let i = 0; i < versionsQuerySnapshot.size; i++) {
            this.versions.push(versionsQuerySnapshot.docs[i].data());
            // if version is the last, resolve promise
            if (i + 1 === versionsQuerySnapshot.size) {
              resolve();
            }
          }
        });
    });
  }

  getProduct(ref: DocumentReference<Product>): void {
    ref.get().then((productDocSnapshot: any) => {
      this.page.product = productDocSnapshot.data();
      this.sharedService.setPageTitle('page');
    });
  }
}
